import type { ClassChildIRepository } from './entity/classChildIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * クラスアプリケーションサービス
 */
export class ClassDomainService extends DomainServiceBase {
  private childClassRepository!: ClassChildIRepository;

  /**
   * Injection
   * @param childClassRepository childClassRepository
   */
  public inject(
    childClassRepository: ClassChildIRepository,
  ) {
    this.childClassRepository = childClassRepository;
  }

  /**
   * getClassChildList
   * @returns items
   */
  async getClassChildList() {
    const items = await this.childClassRepository.getAllList();
    return items;
  }
}
